import { Component, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/organisms/header/header';
import { FooterComponent } from './shared/organisms/footer/footer';
import { SameOriginLinkDirective } from './core/navigation/same-origin-link.directive';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  encapsulation: ViewEncapsulation.None,
  hostDirectives: [SameOriginLinkDirective],
})
export class App {}
